<template>
    <div class="shipping__method__body">
        <div class="shipping__method__body__content">
            <div class="shipping__method__body__header">
                <span class="shipping__method__body__item shipping__method__body__title">
                    <label
                        :for="method.key"
                        class="shipping__method__body__button"
                        :class="{'shipping__method__body__button___active' : shippingMethod?.key === method.key}"
                        @click="selectShippingMethod()"
                    >
                        <input type="radio" name="shippingMethod" :id="method.key">
                        <span class="shipping__method__body__button__icon"></span>
                        <span class="shipping__method__body__button__label">{{method.title}}</span>
                    </label>
                </span>
                <div class="shipping__method__body__item">
                    <span class="shipping__method__body__item__key">هزینه ارسال: </span>
                    <span class="shipping__method__body__item__value">{{method.cost ? numberFormat(method.cost)+' تومان' : 'رایگان'}}</span>
                </div>
            </div>
            <div class="shipping__method__body__description">
                <p>{{method.description}}</p>
            </div>
            <div class="shipping__time-selection" v-if="method.periods?.length">
                <h4 class="shipping__time-selection__header">انتخاب زمان تحویل</h4>
                <div class="shipping__time-selection__body">
                    <ul class="nav shipping__time-selection__nav nav-pills mb-3"
                        id="pills-tab" role="tablist">
                        <li v-for="(day, index) in method.periods" class="nav-item shipping__time-selection__nav-item" role="presentation">
                            <button
                                :class="`nav-link shipping__time-selection__nav-link${index===0 ? ' active' : ''}`"
                                :id="`pills-tab-${index}`"
                                data-bs-toggle="pill"
                                :data-bs-target="`#pills-${index}`"
                                type="button"
                            >
                                <span class="shipping__time-selection__nav-link__date">{{day[0]?.date_beautiful}}</span>
                            </button>
                        </li>
                    </ul>
                    <div class="tab-content shipping__time-selection__tab-content" id="pills-tabContent">
                        <div v-for="(day, index) in method.periods"
                            :class="`tab-pane shipping__time-selection__tab-pane fade${index===0 ? ' show active' : ''}`"
                             :id="`pills-${index}`"
                             role="tabpanel"
                        >
                            <div class="shipping__time-selection__tab-pane__wrapper">
                                <button
                                    v-for="period in day"
                                    class="shipping__time-selection__tab-item"
                                    :class="{
                                        'shipping__time-selection__tab-item--active' : shippingPeriod === period.id,
                                        'shipping__time-selection__tab-item--disable' : !period.has_capacity
                                    }"
                                    @click="selectShippingPeriod(period)"
                                >از ساعت {{period.start_hour}} تا {{period.end_hour}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ShippingMethod",
    emits: ['update:shippingMethod', 'update:shippingPeriod'],
    props: ['shippingMethod', 'shippingPeriod', 'method'],
    methods: {
        selectShippingMethod() {
            this.$emit('update:shippingMethod', this.method);
        },
        selectShippingPeriod(period) {
            this.selectShippingMethod();
            this.$nextTick(() => {
                this.$emit('update:shippingPeriod', period.id);
            });
        }
    },
    watch: {
        shippingMethod() {
            if (this.shippingMethod.key !== this.method.key) {
                this.$emit('update:shippingPeriod', null)
            }
        }
    }
}
</script>

<style scoped>

</style>
